import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './QueryItem.css';
function QueryItem({ data: { title, url, trackingToken, position, userId }, getItemProps, isHighlighted, icon, }) {
    return (React.createElement("a", { ...getItemProps({
            item: {
                title,
                url,
                trackingData: {
                    interaction_type: 'view',
                    consumer: 'rest.api.search.incremental_search',
                    service: 'ds.incremental_search.universal',
                    tracking_token: trackingToken,
                    position: position,
                    user_id: userId,
                },
            },
            href: url,
            className: cx(styles.item, {
                [styles.highlighted]: isHighlighted,
            }),
        }) },
        React.createElement("div", { className: styles.icon }, icon),
        React.createElement("article", { className: styles.content },
            React.createElement("div", { className: styles.title },
                ' ',
                React.createElement(FormattedMessage, { id: "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS", values: {
                        keyword: React.createElement("strong", null, title),
                    } })),
            React.createElement("div", { className: styles.titleShort },
                React.createElement(FormattedMessage, { id: "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS_SHORT", values: {
                        keyword: React.createElement("strong", null, title),
                    } })))));
}
const ItemType = PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    trackingToken: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired,
    userId: PropTypes.string.isRequired,
});
QueryItem.propTypes = {
    data: ItemType.isRequired,
    getItemProps: PropTypes.func.isRequired,
    isHighlighted: PropTypes.bool.isRequired,
    icon: PropTypes.node.isRequired,
};
export default QueryItem;
//# sourceMappingURL=QueryItem.js.map